import React from 'react';

import Hero from '../../presentational/Hero';

function HeroContainer(props) {
  return (
    <Hero className="left" fluid link="carousel-wrapper">
      <h1>Success Stories</h1>
    </Hero>
  )
}

export default HeroContainer;



/** WEBPACK FOOTER **
 ** ./src/components/containers/beforeAfters/HeroContainer.jsx
 **/